// extracted by mini-css-extract-plugin
export default {"appBar":"ResponsiveAppBar_appBar__ZnF6a","logo":"ResponsiveAppBar_logo__fmjCH"};